import { apiSlice } from "@/services/api-slice";
import { Supplier, CreateSupplier, UpdateSupplier } from "./suppliers.interface";
import { APIResponse } from "@/types/custom-http";


export const suppliersApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      // Obtener todos las Proveedores
      getSuppliers: builder.query<APIResponse<Supplier[]>, void>({
        query: () => ({
          url: "auth/warehouse/suppliers"
        }),
        providesTags: ["Suppliers"],
      }),

      // Obtener Proveedores habilitados para OT
      getOtProviders: builder.query<APIResponse<Supplier[]>, void>({
        query: () => ({
          url: "auth/warehouse/suppliers/ot-providers"
        }),
        providesTags: ["Suppliers"],
      }),
      
      // Obtener una Proveedor por ID
      getSupplierById: builder.query<APIResponse<Supplier>, number>({
        query: (id) => ({ url:`/warehouse/suppliers/${id}`}),
        providesTags: (_result, _error, id) => [{ type: 'Suppliers', id }],
      }),

      // Actualizar un Proveedor
      updateSupplier: builder.mutation<APIResponse<Supplier>, { id: number; changes: UpdateSupplier }>({
        query: ({ id, changes }) => ({
          url: `auth/warehouse/suppliers/${id}`,
          method: 'PATCH',
          body: changes,
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'Suppliers', id },'Suppliers'],
      }),
      
      // Crear un nuevo Proveedor
      createSupplier: builder.mutation<APIResponse<Supplier>, CreateSupplier>({
        query: (user) => ({
          url: 'auth/warehouse/suppliers',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['Suppliers', 'ProductUbicationSettings'],
      }),


      // Buscar Proveedores
      searchSuppliers: builder.query<APIResponse<Supplier[]>, string>({
        query: (search) => ({
          url: `auth/warehouse/suppliers/search`,
          params: { search },
        }),
        providesTags: ["Suppliers"],
      })

    }),
  });
  
  export const {
    useGetSuppliersQuery,
    useGetOtProvidersQuery,
    useGetSupplierByIdQuery,
    useCreateSupplierMutation,
    useUpdateSupplierMutation,
    useSearchSuppliersQuery,
    useLazySearchSuppliersQuery
  } = suppliersApi;
